import { useHeaderNavbarQuery } from 'generated/graphql';
import { useMemo } from 'react';



export interface IData {
  profilePictureUrl: string;
  isSuperAdmin: boolean;
  userId: string;
}

export function useQuery() {
  const tuple = useHeaderNavbarQuery();

  return useMemo(
    () => {
      const data: IData = {
        profilePictureUrl: tuple.data?.loggedInUser?.person.profilePicture?.url ?? '',
        isSuperAdmin: tuple.data?.loggedInUser?.isSuperAdmin ?? false,
        userId: tuple.data?.loggedInUser?.id ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
